var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1417 8.33333H6.16666V7.66667H14.1417H15.3455L14.4959 6.8138L12.6981 5.00902L13.1667 4.54044L16.6262 8L13.1679 11.4583L12.6975 10.9846L14.4952 9.18689L15.3488 8.33333H14.1417ZM2.33332 1.66667H1.83332V2.16667V13.8333V14.3333H2.33332H8.49999V15H2.33332C1.6928 15 1.16666 14.4739 1.16666 13.8333V2.16667C1.16666 1.52614 1.6928 1 2.33332 1H8.49999V1.66667H2.33332Z",
    fill: "#344335",
    stroke: "#344335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.79762ed383cbdbd10ccbcd99438ea7ba.svg";
export { ForwardRef as ReactComponent };